import { useQuery } from '@apollo/client/react';

import {
    IDefaultFileType,
    OrganisationDefaultFilesDocument,
} from 'graphql/types';

interface IProps {
    type: IDefaultFileType;
}

export const useInitialDefaultFile = ({ type }: IProps) => {
    const { data, loading, error } = useQuery(
        OrganisationDefaultFilesDocument,
        {
            variables: { type },
        }
    );

    const defaultFiles = data?.organisationDefaultFiles || [];
    const initialFile = defaultFiles.length ? defaultFiles[0].file : undefined;

    return { initialFile, loading, error };
};
